// extracted by mini-css-extract-plugin
export default {"buttons":"wFCCw"};